import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String!',
	'response_value': 'String!',
};

export default gql(`
	mutation email_external_response( ${ HelperGraphql.createFields( fields ) } ) {
	    email_external_response( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	    }
	}
`);

